export default "__VITE_ASSET__jZ7XJ9IE__"